/*! sku-media-filter.js */
(function () {
  // ---------- Utils ----------
  const LOG_PREFIX = '[SKU-Filter]';
  const THUMB_SLIDE_SELECTOR = '.m-product-media--slider__thumbnails .swiper-slide';
  const SKU_EL_SELECTOR = '.m-product-meta--value[data-variant-sku]';

  // Normaliza string
  function norm(str) {
    return String(str || '').trim().toUpperCase();
  }

  // Injeta CSS para ocultar thumbs marcadas
  function ensureHideCss() {
    const id = 'sku-filter-hide-css';
    if (document.getElementById(id)) return;
    const style = document.createElement('style');
    style.id = id;
    style.textContent = `
      .swiper-slide.swiper-slide-hidden-by-sku { display: none !important; }
      .m-product-media--slider__thumbnails .swiper-slide.swiper-slide-hidden-by-sku { display: none !important; }
    `;
    document.head.appendChild(style);
  }

  // Lê o SKU atual diretamente do bloco meta
  function getSelectedSKU() {
    const el = document.querySelector(SKU_EL_SELECTOR);
    if (!el) return null;

    // prioridade: atributo data-variant-sku; fallback: texto
    const fromAttr = (el.getAttribute('data-variant-sku') || '').trim();
    const fromText = (el.textContent || '').trim();
    const sku = fromAttr || fromText;
    return sku ? norm(sku) : null;
  }

  // Quebra SKU e gera candidatos de "base" (para casar sem o tamanho, etc.)
  // Ex.: 1801_VERM_M → { full:"1801_VERM_M", base:"1801_VERM", tokens:["1801","VERM","M"] }
  function deriveSkuCandidates(sku) {
    const full = norm(sku);
    const parts = full.split('_').filter(Boolean);
    let base = full;

    if (parts.length >= 2) {
      // remove o último token (geralmente tamanho) → 1801_VERM
      base = parts.slice(0, parts.length - 1).join('_');
    }

    return { full, base, tokens: parts };
  }

  // Extrai "key" da thumb: ALT, data-media-alt, ou nome de arquivo
  function getMediaKeyFromSlide(slide) {
    if (!slide) return '';

    // Pode estar no próprio slide
    let key =
      slide.getAttribute('data-media-alt') ||
      slide.getAttribute('data-alt') ||
      '';

    // Ou em filhos
    const media = slide.querySelector('.m-product-media, [data-media-alt]');
    const img = slide.querySelector('img');

    key =
      key ||
      (img && img.getAttribute('alt')) ||
      (media && media.getAttribute('data-media-alt')) ||
      '';

    key = norm(key);

    if (!key) {
      const src =
        (media && media.getAttribute('data-media-src')) ||
        (img && img.getAttribute('src')) ||
        '';
      const m = String(src).match(
        /\/([^\/?#]+)\.(png|jpg|jpeg|webp|gif)(?=[?#]|$)/i
      );
      if (m && m[1]) key = norm(m[1]); // ex.: "1801_VERM_M"
    }

    return key;
  }

  // Regras de casamento SKU ↔ key
  // 1) igual ao SKU completo
  // 2) começa com o SKU completo
  // 3) contém o SKU completo
  // 4) começa com base (sem tamanho)
  // 5) contém base
  // 6) contém os tokens do SKU em ordem (ex.: 1801 + VERM)
  function matchBySKU(key, selectedSKU) {
    if (!key || !selectedSKU) return false;

    const { full, base, tokens } = deriveSkuCandidates(selectedSKU);

    // 1/2/3: com o SKU completo
    if (key === full) return true;
    if (key.startsWith(full)) return true;
    if (key.includes(full)) return true;

    // 4/5: com a base (sem tamanho)
    if (base && (key.startsWith(base) || key.includes(base))) return true;

    // 6: tokens em ordem
    let idx = 0;
    for (const t of tokens) {
      const found = key.indexOf(t, idx);
      if (found === -1) return false;
      idx = found + t.length;
    }
    return true;
  }

  // Marca/Desmarca slide como oculto
  function setHiddenSlide(slide, hide) {
    slide.classList.toggle('swiper-slide-hidden-by-sku', !!hide);
  }

  // Atualiza o Swiper mais próximo (para recalcular layout)
  function updateSwiperUnder(container) {
    if (!container) return;
    const el =
      container.closest?.('.nav-swiper-container') ||
      container.querySelector?.('.nav-swiper-container') ||
      container;
    const swiper = el?.swiper || container?.swiper;
    if (swiper && typeof swiper.update === 'function') {
      try {
        swiper.updateSize && swiper.updateSize();
        swiper.updateSlides && swiper.updateSlides();
        swiper.updateAutoHeight && swiper.updateAutoHeight();
        swiper.update();
      } catch (e) {
        // silencioso
      }
    }
  }

  // Aplica filtro às thumbnails
  function updateThumbsBySKU(selectedSKU) {
    if (!selectedSKU) selectedSKU = getSelectedSKU();
    if (!selectedSKU) return;

    const slides = document.querySelectorAll(THUMB_SLIDE_SELECTOR);
    if (!slides.length) return;

    let anyVisible = false;

    slides.forEach((slide) => {
      const key = getMediaKeyFromSlide(slide);
      const show = matchBySKU(key, selectedSKU);
      setHiddenSlide(slide, !show);
      if (show) anyVisible = true;
    });

    // Se nada casou, não esconda tudo (evita thumbs vazias)
    if (!anyVisible) {
      slides.forEach((slide) => setHiddenSlide(slide, false));
    }

    const nav =
      document.querySelector('.m-product-media--slider__thumbnails .nav-swiper-container') ||
      document.querySelector(
        '.m-product-media--slider__thumbnails .swiper, .m-product-media--slider__thumbnails .swiper-container'
      );

    updateSwiperUnder(nav);
  }

  // Roda tudo
  function runAll() {
    ensureHideCss();
    updateThumbsBySKU();
  }

  // Inicialização segura (espera thumbs aparecerem)
  function safeInit() {
    let tries = 0;
    function tick() {
      tries++;
      runAll();
      const sku = getSelectedSKU();
      const thumbsExist = document.querySelector(THUMB_SLIDE_SELECTOR);
      if ((sku && thumbsExist) || tries >= 12) return; // ~1.2s
      setTimeout(tick, 100);
    }
    tick();
  }

  // Observa o bloco de SKU especificamente
  function observeSkuBlock() {
    const skuBlock = document.querySelector(SKU_EL_SELECTOR);
    if (!skuBlock) return;

    const observer = new MutationObserver(() => {
      // debounce curto
      clearTimeout(observer._t);
      observer._t = setTimeout(runAll, 80);
    });

    // Observa mudanças no texto (characterData) e atributos (data-variant-sku)
    observer.observe(skuBlock.parentNode || skuBlock, {
      childList: true,
      subtree: true,
      characterData: true,
    });
    observer.observe(skuBlock, {
      attributes: true,
      attributeFilter: ['data-variant-sku'],
    });
  }

  // Observa mudanças gerais na galeria (thumbs recriadas etc.)
  function observeGallery() {
    const mo = new MutationObserver(() => {
      clearTimeout(mo._t);
      mo._t = setTimeout(runAll, 100);
    });
    mo.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: false,
      attributeFilter: ['class', 'src', 'alt', 'data-media-alt'],
    });
  }

  // Eventos de interação (mudança de variações, clique em thumb, etc.)
  function bindUIEvents() {
    document.addEventListener('change', (ev) => {
      const t = ev.target;
      if (
        t &&
        t.matches(
          '.swatch--input, [name^="options["], [name^="option"], select[name*="option"]'
        )
      ) {
        setTimeout(runAll, 80);
      }
    });

    document.addEventListener('click', (ev) => {
      const slide = ev.target.closest(THUMB_SLIDE_SELECTOR);
      if (!slide) return;
      const sku = getSelectedSKU();
      if (sku) updateThumbsBySKU(sku);
    });
  }

  // ---- Boot ----
  if (document.readyState === 'complete') {
    safeInit();
  } else {
    window.addEventListener('load', safeInit);
    document.addEventListener('DOMContentLoaded', runAll);
  }

  observeSkuBlock();
  observeGallery();
  bindUIEvents();

//   Descomente para ver debug no console:
  setTimeout(() => {
    const sku = getSelectedSKU();
    const thumbs = document.querySelectorAll(THUMB_SLIDE_SELECTOR);
    console.groupCollapsed(`${LOG_PREFIX} Debug`);
    console.log('SKU:', sku);
    console.log('Thumbs:', thumbs.length);
    thumbs.forEach((sl, i) => {
      console.log(`#${i}`, {
        key: getMediaKeyFromSlide(sl),
        src: sl.querySelector('img')?.src || null
      });
    });
    console.groupEnd();
  }, 500);
})();
